import { Component, inject } from '@angular/core';
import { MetaDataService } from '../metadata.service';

@Component({
    selector: 'tea-shop-fe-vdp',
    templateUrl: './vdp.component.html',
    styleUrl: './vdp.component.css'
})
export class VdpComponent {
    private metaDataService = inject(MetaDataService);

  
    constructor() { 
      this.metaDataService.updateMetadata({
        title: 'Vulnerability Disclosure Program',
        image: '/assets/contact/sencha-logo.png',
      });
    }
}
